export const correos_copia = [
    "oportunidades.comercial@airtek.com.ve",
    "sandra.fernandez@airtek.com.ve",
    "ivan.bello@airtek.com.ve"
  ];
